import { ResponseService } from './response.service';
import { Company } from './../interfaces/company.model';
import { CompanyService } from '../services/company.service';
import { ReplaySubject } from 'rxjs/Rx';
import { ApiService } from '../services/api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ContractsService {

  private company: Company;
  private oContracts = new ReplaySubject(1);
  private oContract = new ReplaySubject(1);
  private oContractServices = new ReplaySubject(1);

  SETTLEMENT_DAILY = 1;
  SETTLEMENT_MONTHLY = 2;
  SETTLEMENT_QUARTERLY = 3;
  SETTLEMENT_SEMIANNUALLY = 4;
  SETTLEMENT_ANNUALLY = 5;

  PERPETUAL_YES = 1;
  PERPETUAL_NO = 0;

  STATUS_IN_PROGRESS = 1;
  STATUS_PAYMENT_REQUIRED = 2;
  STATUS_ACTIVE = 3;
  STATUS_FINISHED = 4;

  constructor(
    private apiService: ApiService,
    private companyService: CompanyService,
    private responseService: ResponseService
  ) {
    this.companyService.getSelectedCompanyEmitter().subscribe(
      (company: Company) => {
        this.company = company;
      }
    );
  }

  getCompanyContracts(id) {
    this.apiService.get('/company/' + id + '/contracts').subscribe(
      (response) => {
        const contracts = this.responseService.success(false, response, 'contracts');
        this.oContracts.next(contracts);
      },
      (error) => {
        this.responseService.error(error);
        this.oContracts = new ReplaySubject(1);
      }
    )

    return this.oContracts;
  }

  getContract(companyID, contractID) {
    this.apiService.get('/company/' + companyID + '/contract/' + contractID).subscribe(
      (response) => {
        const contract = this.responseService.success(false, response, 'contract');
        this.oContract.next(contract)
      },
      (error) => {
        this.responseService.error(error);
        this.oContract = new ReplaySubject(1);
      }
    );
    return this.oContract;
  }

  getContractServices(companyID, contractID) {
    this.apiService.get('/company/' + companyID + '/contract/' + contractID + '/services').subscribe(
      (response) => {
        const services = this.responseService.success(false, response, 'services');
        this.oContractServices.next(services);
      },
      (error) => {
        this.responseService.error(error);
        this.oContractServices = new ReplaySubject(1);
      }
    );
    return this.oContractServices;
  }

  getContractItem(companyID, contractID, itemID) {
    this.apiService.get('/company/' + companyID + '/contract/' + contractID + '/service/' + itemID).subscribe(
      (response) => {
        const item = this.responseService.success(false, response);
        return item;
      },
      (error) => {
        this.responseService.error(error);
      }
    );
  }

  changeContractName(companyID, contractID, name) {
    this.apiService.put('/company/' + companyID + '/contract/' + contractID, {
      company_id: companyID,
      contract_id: contractID,
      name: name
    }).subscribe(
      (response) => {
        const contract = this.responseService.success(true, response, 'contract', 'changename');
        this.oContract.next(contract);
      },
      (error) => {
        this.responseService.error(error);
        this.oContract = new ReplaySubject(1);
      }
    );

    return this.oContract;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contracts.service.ts